import { render } from "./AddProjectSupplierContent.vue?vue&type=template&id=619ca7b6&scoped=true"
import script from "./AddProjectSupplierContent.vue?vue&type=script&lang=js"
export * from "./AddProjectSupplierContent.vue?vue&type=script&lang=js"

import "./AddProjectSupplierContent.vue?vue&type=style&index=0&id=619ca7b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-619ca7b6"]])

export default __exports__